// extracted by mini-css-extract-plugin
export default {"fileContainer":"fileContainer___wh9hg","text":"text___d7W1w","buttonWrapper":"buttonWrapper___CAj7K"};